<template>
  <v-expand-transition>
    <div
      :id="sectionElId(section)"
      style="padding: 10px 0 10px 0;"
      v-html="section.text"
      v-if="showParagraph"
    >
    </div>
  </v-expand-transition>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalConstants from '@/globals'

export default {
  name: 'UserFormParagraph',
  props: ['userFormId', 'section'],
  methods: {
    sectionElId (section) {
      return `section-${section.id}`
    }
  },
  computed: {
    ...mapGetters('userform', [
      'answer',
      'parts'
    ]),
    showParagraph(){
      if (!this.checkPermission('userform', this.PERMISSIONS.CAN_EDIT) && this.checkPermission('userform', this.PERMISSIONS.CAN_CONTACT_EDIT))
        return GlobalConstants.MeetsCondition(this.section, this.answer, this.parts)
      return true
    },
  }
}
</script>

<style scoped>
  div >>> p {
    margin: 0 !important;
  }
</style>